import React, { useState } from 'react'
import { Tabs, Tab, Box, Skeleton } from '@mui/material'
import VersionDisplay from '../components/VersionDisplay'
import HomeTabContent from '../components/HomeTabContent'
import { resolveEnabledModules, isModuleEnabled } from '../config/permissions-registry'
import GroupIcon from '@material-ui/icons/Group'
import PersonSearchIcon from '@mui/icons-material/PersonSearch'
import SubjectIcon from '@material-ui/icons/Subject'
import AccountCircleIcon from '@material-ui/icons/AccountCircle'
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart'
import FolderSharedIcon from '@material-ui/icons/FolderShared'
import LocalAtmIcon from '@material-ui/icons/LocalAtm'
import LocalOfferIcon from '@material-ui/icons/LocalOffer'
import PlaceIcon from '@material-ui/icons/Place'
import AccountBalanceIcon from '@material-ui/icons/AccountBalance'
import MonetizationOnIcon from '@material-ui/icons/MonetizationOn'
import PlaylistAddCheckIcon from '@material-ui/icons/PlaylistAddCheck'
import AssessmentIcon from '@material-ui/icons/Assessment'
import PieChartIcon from '@material-ui/icons/PieChart'
import PriceCheckIcon from '@mui/icons-material/PriceCheck'
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong'
import PermContactCalendarIcon from '@mui/icons-material/PermContactCalendar'
import ReceiptIcon from '@mui/icons-material/Receipt'
import AssignmentIcon from '@mui/icons-material/Assignment'
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile'
import PaymentsIcon from '@mui/icons-material/Payments'
import BeenhereIcon from '@mui/icons-material/Beenhere'
import GavelIcon from '@mui/icons-material/Gavel'
import AccessTimeIcon from '@mui/icons-material/AccessTime'
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn'
import CalendarTodayIcon from '@mui/icons-material/CalendarToday'
import ScheduleIcon from '@mui/icons-material/Schedule'
import DescriptionIcon from '@mui/icons-material/Description'

const iconFontSize = '30px'

const homeTabs = [
  {
    label: 'Lawson (S3)',
    sections: [
      {
        title: 'HR / Payroll',
        permission: 'HR',
        tiles: [
          {
            title: 'Employee',
            icon: <GroupIcon style={{ fontSize: iconFontSize }} />,
            link: 'employee'
          },
          {
            title: 'Employee Advanced Search',
            icon: <GroupIcon style={{ fontSize: iconFontSize }} />,
            link: 'employee-advanced-search'
          },
          {
            title: 'Absence Management',
            icon: <CalendarTodayIcon style={{ fontSize: iconFontSize }} />,
            link: 'absence-management'
          },
          {
            title: 'Garnishments (PR26)',
            icon: <GavelIcon style={{ fontSize: iconFontSize }} />,
            link: 'garnishment'
          },
          {
            title: 'LOA (LP51)',
            icon: <AccessTimeIcon style={{ fontSize: iconFontSize }} />,
            link: 'lp51'
          },
          {
            title: 'Length of Service',
            icon: <ScheduleIcon style={{ fontSize: iconFontSize }} />,
            link: 'length-of-service'
          },
          {
            title: 'Payroll Distribution',
            icon: <AssignmentTurnedInIcon style={{ fontSize: iconFontSize }} />,
            link: 'payroll-distribution'
          }
        ]
      },
      {
        title: 'AP',
        permission: 'AP',
        tiles: [
          {
            title: 'Accounts Payable',
            icon: <FolderSharedIcon style={{ fontSize: iconFontSize }} />,
            link: 'vendor'
          },
          {
            title: 'Invoice Matching',
            icon: <BeenhereIcon style={{ fontSize: iconFontSize }} />,
            link: 'invoice-matching'
          }
        ]
      },
      {
        title: 'AR',
        permission: 'AR',
        tiles: [
          {
            title: 'Accounts Receivable',
            icon: <PermContactCalendarIcon style={{ fontSize: iconFontSize }} />,
            link: 'customer-activity'
          },
          {
            title: 'AR Invoice Lookup',
            icon: <ReceiptLongIcon style={{ fontSize: iconFontSize }} />,
            link: 'ar-invoice'
          }
        ]
      },
      {
        title: 'GL',
        permission: 'GL',
        tiles: [
          {
            title: 'Chart Of Accounts',
            icon: <AccountCircleIcon style={{ fontSize: iconFontSize }} />,
            link: 'gl-accounts'
          },
          {
            title: 'Transactions',
            icon: <SubjectIcon style={{ fontSize: iconFontSize }} />,
            link: 'gl-trans'
          },
          {
            title: 'Trial Balances',
            icon: <PriceCheckIcon style={{ fontSize: iconFontSize }} />,
            link: 'trial-balances'
          },
          {
            title: 'Trial Balances Consolidated',
            icon: <PriceCheckIcon style={{ fontSize: iconFontSize }} />,
            link: 'trial-balances-consolidated'
          },
          {
            title: 'Journal Control (GL45)',
            icon: <AccountBalanceIcon style={{ fontSize: iconFontSize }} />,
            link: 'journal-control'
          }
        ]
      },
      {
        title: 'Asset Management',
        permission: 'ASSET',
        tiles: [
          {
            title: 'Asset (AM20)',
            icon: <LocalAtmIcon style={{ fontSize: iconFontSize }} />,
            link: 'assets'
          },
          {
            title: 'Asset Analysis (AM70.1)',
            icon: <PieChartIcon style={{ fontSize: iconFontSize }} />,
            link: 'asset-analysis'
          },
          {
            title: 'Transaction Analysis (AM80.1)',
            icon: <AssessmentIcon style={{ fontSize: iconFontSize }} />,
            link: 'transaction-analysis'
          }
        ]
      },
      {
        title: 'Procurement',
        permission: 'PO',
        tiles: [
          {
            title: 'PO',
            icon: <ShoppingCartIcon style={{ fontSize: iconFontSize }} />,
            link: 'po'
          },
          {
            title: 'Item (IC11)',
            icon: <LocalOfferIcon style={{ fontSize: iconFontSize }} />,
            link: 'item'
          },
          {
            title: 'Item Location / Transactions (IC12/IC50)',
            icon: <PlaceIcon style={{ fontSize: iconFontSize }} />,
            link: 'item-loc'
          },
          {
            title: 'Requisition (RQ44)',
            icon: <PlaylistAddCheckIcon style={{ fontSize: iconFontSize }} />,
            link: 'requisition-inquiry'
          },
          {
            title: 'PO Search',
            icon: <AssignmentIcon style={{ fontSize: iconFontSize }} />,
            link: 'po-inquiry'
          },
          {
            title: 'PO Receipt',
            icon: <InsertDriveFileIcon style={{ fontSize: iconFontSize }} />,
            link: 'po-receipt'
          },
          {
            title: 'Vendor Agreement',
            icon: <DescriptionIcon style={{ fontSize: iconFontSize }} />,
            link: 'vendor-agreement'
          }
        ]
      },
      {
        title: 'Cash Book',
        permission: 'CASH',
        tiles: [
          {
            title: 'Cash Book Trans (CB80)',
            icon: <MonetizationOnIcon style={{ fontSize: iconFontSize }} />,
            link: 'cash-book-trans'
          },
          {
            title: 'Cash Payment (CB 56)',
            icon: <PaymentsIcon style={{ fontSize: iconFontSize }} />,
            link: 'cash-payment-inquiry'
          }
        ]
      },
      {
        title: 'Activity',
        permission: 'ACTIVITY',
        tiles: [
          {
            title: 'ACTRANS by Activity',
            icon: <ReceiptLongIcon style={{ fontSize: iconFontSize }} />,
            link: 'actrans-activity'
          },
          {
            title: 'ACTRANS by Period',
            icon: <ReceiptLongIcon style={{ fontSize: iconFontSize }} />,
            link: 'actrans'
          },
          {
            title: 'Bill of Cost (AC471)',
            icon: <ReceiptIcon style={{ fontSize: iconFontSize }} />,
            link: 'bill-cost'
          }
        ]
      }
    ]
  },
  {
    label: 'Infor GHR',
    sections: [
      {
        title: 'HR / Payroll',
        permission: 'HR',
        tiles: [
          {
            title: 'Resource',
            icon: <GroupIcon style={{ fontSize: iconFontSize }} />,
            link: 'resource'
          },
          {
            title: 'Candidate',
            icon: <PersonSearchIcon style={{ fontSize: iconFontSize }} />,
            link: 'candidate'
          }
        ]
      }
    ]
  }
]

export default function Home (props) {
  const [activeTab, setActiveTab] = useState(0)

  const credentials = props?.fetchInitialData?.credentials
  const loading = !credentials

  const allow = credentials?.allow || (() => false)
  const allowPage = (subkey) => allow('page', subkey)
  const rawModules = credentials?.clientModules
  const clientModules = resolveEnabledModules(rawModules)

  const isTabVisible = (tab) =>
    tab.sections.some(section =>
      isModuleEnabled(section.permission, clientModules) &&
      section.tiles.some(tile => allowPage(tile.link))
    )

  const visibleTabs = loading ? [] : homeTabs.filter(isTabVisible)
  const showTabs = visibleTabs.length >= 2
  const safeActiveTab = Math.min(activeTab, Math.max(0, visibleTabs.length - 1))
  const currentSections = visibleTabs[safeActiveTab]?.sections || []

  return (
    <div style={{ padding: '1rem 1rem' }}>
      {loading && (
        <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 2, display: 'flex', gap: 2, pb: 0.5 }}>
          <Skeleton variant='text' width={110} height={44} />
          <Skeleton variant='text' width={90} height={44} />
        </Box>
      )}

      {showTabs && (
        <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}>
          <Tabs
            value={safeActiveTab}
            onChange={(_, v) => setActiveTab(v)}
            textColor='primary'
            indicatorColor='primary'
          >
            {visibleTabs.map(tab => (
              <Tab key={tab.label} label={tab.label} />
            ))}
          </Tabs>
        </Box>
      )}

      {!loading && visibleTabs.length === 0 ? (
        <div style={{ textAlign: 'center', marginTop: '4rem', color: '#666' }}>
          You don't have permission to access any modules. Contact your administrator.
        </div>
      ) : (
        <HomeTabContent
          sections={currentSections}
          allowPage={allowPage}
          history={props.history}
          clientModules={clientModules}
          loading={loading}
        />
      )}

      <div
        style={{
          position: 'fixed',
          bottom: '10px',
          right: '10px',
          zIndex: 1000,
        }}
      >
        <VersionDisplay
          style={{
            fontSize: '12px',
            color: '#666',
            backgroundColor: 'rgba(255, 255, 255, 0.8)',
            padding: '4px 8px',
            borderRadius: '4px',
            border: '1px solid #ddd'
          }}
        />
      </div>
    </div>
  )
}
